import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { OurClientsComponent } from './our-clients.component';
import { SharedTitleModule } from 'app/shared-title/shared-title.module';
import { SharedHeaderModule } from 'app/shared-header/shared-header.module';

@NgModule({
  declarations: [
    OurClientsComponent
  ],
  imports: [
    CommonModule,
    NgbModule, 
    SharedTitleModule,
    SharedHeaderModule
  ],exports:[
    OurClientsComponent,
  ]
})
export class OurClientsModule { }
